import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
		this.observer = null;
	}

	init() {
		this.destroyObservers();

		this.observeAnimations();

		const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

		if (isTouchDevice) {
			document.body.classList.add("-is-touch");
		} else {
			document.body.classList.add("-is-no-touch");
		}
	}

	destroyObservers() {
		if (this.observer) {
			this.observer.disconnect();
			this.observer = null;
		}
	}

	observeAnimations() {
		const elements = document.querySelectorAll("[data-animation]");

		if (!elements.length) return;

		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const animationClass = entry.target.dataset.animation;

						if (animationClass) {
							entry.target.classList.add("a-" + animationClass);
						} else {
							entry.target.classList.add("-in-view");
						}
					}
				});
			},
			{ threshold: 0.3 }
		);

		elements.forEach((el) => this.observer.observe(el));
	}

	// This method is called by the Swup integration to destroy the old instance
	destroy() {
		this.destroyObservers();
	}
}
